// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3juYo","buttons":"SendReceipts_buttons__2jvf7","email":"SendReceipts_email__3S4NK","bookApptTitle":"SendReceipts_bookApptTitle__2w6IK"};